/* eslint-disable no-inner-declarations */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
import type {ChangeEvent, FormEvent} from 'react';
import {useEffect, useState} from 'react';
import {
	Button,
	Form,
	Modal,
	Accordion,
	Tooltip,
	OverlayTrigger,
} from 'react-bootstrap';
import ActionForm from './forms/ActionForm';
import ConditionForm from './forms/ConditionForm';
import HeaderForm from './forms/HeaderForm';
import WorkflowSummary from './forms/WorkflowSummary';
import type {IStateConditionAction, Xml2Js, Transformation} from 'interfaces';
import {useAppDispatch, useAppSelector} from 'store/hooks';
import {setPolicyRow} from 'store/policyRowSlice';
import TransformationsForm from './forms/TransformationsForm';
import type {AccordionEventKey} from 'react-bootstrap/esm/AccordionContext';
import {removeTransformations} from 'utils';

type TProps = {
	onAddRow: (row: Xml2Js, key: 'Gw' | 'App', isEdit: boolean) => void;
	onClose: () => void;
	show: boolean;
	keyModal: 'Gw' | 'App';
	rowData: Xml2Js;
};
export interface IHeaderForm {
	name: string;
	priority: string;
	scope: string | undefined;
	enabled: boolean;
}

const defaultHeaderForm = (keyModal: string) => ({
	name: '',
	priority: '',
	scope: keyModal,
	enabled: false,
});

const ModalPolicyCreateOrEditXML = ({
	show,
	onAddRow,
	onClose,
	keyModal,
	// data edit
	rowData,
}: TProps) => {
	const dispatch = useAppDispatch();

	const policyRow = useAppSelector(state => state.policyRow);

	const [isValidForm, setIsValidForm] = useState(true);
	const [state, setState] = useState<IStateConditionAction | undefined>();
	const [headerForm, setHeaderForm] = useState<IHeaderForm>(
		defaultHeaderForm(keyModal),
	);

	const [isEdit, setIsEdit] = useState(false);
	const [activeKeys, setActiveKeys] = useState<string[]>([]);
	const handleSelect = (eventKey: AccordionEventKey) =>
		setActiveKeys(eventKey as string[]);
	const handleToggleClick = () => setActiveKeys(['0', '1', '2']);
	const handleCollapseClick = () => setActiveKeys([]);

	// all collapse close
	useEffect(() => handleCollapseClick(), [show]);

	useEffect(() => {
		setIsEdit(rowData && rowData?.$.name !== '' ? true : false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [rowData?.$.name]);

	/* `useEffect` is a hook in React that allows you to perform side effects in function components. In
	this case, it is used to update the `scope` property of the `headerForm` state object whenever the
	`keyModal` prop changes. */
	useEffect(() => {
		const defaultHeader = defaultHeaderForm(keyModal);
		if (rowData && keyModal) {
			const {name, priority, enabled} = rowData.$;

			setHeaderForm(prevState => ({
				...prevState,
				scope: keyModal,
				name,
				priority,
				enabled: JSON.parse(enabled),
			}));
		} else {
			setHeaderForm(defaultHeader);
		}
	}, [keyModal, rowData]);

	// clean default data in modal create
	useEffect(() => {
		if (!rowData) {
			const defaultHeader = defaultHeaderForm(keyModal);
			setHeaderForm(defaultHeader);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [show]);

	/**
	 * This function updates the state of a form based on user input.
	 * @param {ChangeEvent<HTMLInputElement>} e - The parameter `e` is an event object that is passed to the `handleHeaderForm`
	 * function. It contains information about the event that triggered the function, such as the target
	 * element that was interacted with.
	 */
	const handleHeaderForm = ({target}: ChangeEvent<HTMLInputElement>) => {
		const {name, value, checked = false, type} = target;
		const limit = 5;
		const newValue = type === 'number' ? value.slice(0, limit) : value;

		setHeaderForm(prevState => ({
			...prevState,
			[name]: type === 'checkbox' ? checked : newValue,
		}));
	};

	/**
	 * This is a TypeScript React function that updates the state with the argument passed in.
	 * @param {Xml2Js} arg - Xml2Js is likely a type definition for an object that represents an XML
	 * document that has been parsed into a JavaScript object. The `arg` parameter is of this type and is
	 * being used to update the state of the component.
	 */
	const handleChange = (arg: Xml2Js) => {
		setState((prevState: IStateConditionAction | any) => ({
			...prevState,
			...arg,
		}));
	};

	useEffect(() => {
		if (state) {
			dispatch(setPolicyRow(state));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state]);

	const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		const tmpPolicyRow = JSON.parse(JSON.stringify(policyRow));

		if (tmpPolicyRow) {
			const transformationsArray = tmpPolicyRow?.transformations || [];

			// Crear transformationObject con la estructura correcta
			const transformationObject: Transformation = {
				ReMap: transformationsArray.map((item: any) => {
					// Verificar si el objeto ya tiene la estructura ReMap
					if (item._ && !item.ReMap) {
						return {_: item._, $: item.$}; // Si no, envolverlo en un objeto ReMap
					} else {
						return item; // Si ya tiene la estructura ReMap, devolver el objeto tal cual
					}
				}),
			};

			const row: Xml2Js | any = {
				$: {...headerForm},
				conditions: tmpPolicyRow.conditions,
				actions: tmpPolicyRow.actions,
				transformations:
					transformationObject?.ReMap?.length > 0
						? [transformationObject]
						: null,
			};

			removeTransformations(row);

			onAddRow(row, keyModal, isEdit);
			onClose();
		}
	};

	const handleObserverInputs = (isValid: boolean) => {
		if (isValid) {
			setIsValidForm(true);
			return;
		}

		setIsValidForm(false);
	};

	return (
		<Modal
			backdrop="static"
			size="xl"
			show={show}
			onHide={onClose}
			dialogClassName="modal-90w"
			aria-labelledby="example-custom-modal-styling-title">
			<Form onSubmit={e => handleSubmit(e)}>
				<Modal.Header closeButton>
					<Modal.Title id="example-custom-modal-styling-title">
						<i className="bi bi-filetype-xml text-dark mr-2" />{' '}
						{!rowData ? 'Create' : 'Edit'}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="bg-gray-100">
					<div
						className="modal-body overflow-auto"
						style={{maxHeight: '50rem'}}>
						{/* sticky buttons */}
						<div className="col text-right sticky-top mt-n4">
							<Button
								type="button"
								className="btn btn-labeled btn-primary btn-sm z-index mr-1"
								onClick={() => handleToggleClick()}>
								<span className="btn-label mr-2">
									<i className="bi-1 bi-chevron-expand" />
								</span>
								Expand all
							</Button>

							<Button
								type="button"
								className="btn btn-labeled btn-primary btn-sm z-index"
								onClick={() => handleCollapseClick()}>
								<span className="btn-label mr-2">
									<i className="bi-1 bi-chevron-bar-expand" />
								</span>
								Collapse all
							</Button>
						</div>

						<HeaderForm
							form={headerForm}
							onChange={handleHeaderForm as never}
						/>

						<WorkflowSummary stateRowData={state} />

						<Accordion
							alwaysOpen
							activeKey={activeKeys}
							onSelect={handleSelect}>
							<Accordion.Item eventKey="0" className="rounded border">
								<Accordion.Header className="bg-gray-300">
									Conditions
								</Accordion.Header>
								<Accordion.Body className="pt-4">
									<ConditionForm
										onChange={handleChange}
										rowData={rowData}
										typeForm={keyModal}
										onObserver={handleObserverInputs}
									/>
								</Accordion.Body>
							</Accordion.Item>

							<Accordion.Item eventKey="1" className="rounded border my-3">
								<Accordion.Header className="bg-gray-300">
									Actions
								</Accordion.Header>
								<Accordion.Body className="pt-4">
									<ActionForm
										onChange={handleChange}
										rowData={rowData}
										onObserver={handleObserverInputs}
										typeForm={keyModal}
									/>
								</Accordion.Body>
							</Accordion.Item>

							<Accordion.Item eventKey="2" className="rounded border my-3">
								<Accordion.Header
									className="accordion-header position-relative"
									id="panelsTransformation-headingTwo">
									<div className="d-flex justify-content-between">
										<div className="align-items-end justify-content-end">
											<div className="ml-0">Transformations</div>
										</div>
									</div>
								</Accordion.Header>
								<Accordion.Body className="pt-4">
									<TransformationsForm
										onChange={handleChange as never}
										rowData={rowData}
										isEdit={isEdit}
									/>
								</Accordion.Body>
							</Accordion.Item>
						</Accordion>
					</div>
				</Modal.Body>
				<Modal.Footer className="d-flex justify-content-between">
					<Button variant="secondary" onClick={() => onClose()}>
						Close
					</Button>
					<Button variant="primary" type="submit" disabled={!isValidForm}>
						Save changes
					</Button>
				</Modal.Footer>
			</Form>
		</Modal>
	);
};

export default ModalPolicyCreateOrEditXML;
